module.exports = __webpack_public_path__ + "static/media/logo-results.b48e9ca7.svg";